import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useContext, useEffect, useRef, useState } from 'react';
import classnames from 'classnames/bind';
import { Button } from "../../Button/Button/Button";
import { Icon } from "../../Icon/Icon/Icon";
import { SpinnerIndicator } from "../../Indicator/SpinnerIndicator/SpinnerIndicator";
import { TextInput } from "../TextInput/TextInput";
import { Theme } from "../../Background/Theme/Theme";
import { ThemeContext } from "../../../context/theme.context";
import Utility from "../../Utility/Utility";
import styles from "./InputGroup.module.scss";

// Classnames bind variant.
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var cx = classnames.bind(styles);
export var InputGroup = function InputGroup(_ref) {
  var _ref$arrowButton = _ref.arrowButton,
    arrowButton = _ref$arrowButton === void 0 ? false : _ref$arrowButton,
    _ref$autoFocus = _ref.autoFocus,
    autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
    _ref$buttonAttributes = _ref.buttonAttributes,
    buttonAttributes = _ref$buttonAttributes === void 0 ? {} : _ref$buttonAttributes,
    _ref$buttonClassName = _ref.buttonClassName,
    buttonClassName = _ref$buttonClassName === void 0 ? '' : _ref$buttonClassName,
    buttonText = _ref.buttonText,
    _ref$hasError = _ref.hasError,
    hasError = _ref$hasError === void 0 ? false : _ref$hasError,
    _ref$id = _ref.id,
    initId = _ref$id === void 0 ? '' : _ref$id,
    _ref$inputAttributes = _ref.inputAttributes,
    inputAttributes = _ref$inputAttributes === void 0 ? {} : _ref$inputAttributes,
    _ref$inputClassName = _ref.inputClassName,
    inputClassName = _ref$inputClassName === void 0 ? '' : _ref$inputClassName,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    _ref$onChangeText = _ref.onChangeText,
    onChangeText = _ref$onChangeText === void 0 ? function () {} : _ref$onChangeText,
    _ref$onKeyDown = _ref.onKeyDown,
    onKeyDown = _ref$onKeyDown === void 0 ? function () {} : _ref$onKeyDown,
    _ref$onSubmit = _ref.onSubmit,
    onSubmit = _ref$onSubmit === void 0 ? function () {} : _ref$onSubmit,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
    _ref$small = _ref.small,
    small = _ref$small === void 0 ? false : _ref$small,
    _ref$text = _ref.text,
    initText = _ref$text === void 0 ? '' : _ref$text,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant;
  var theme = useContext(ThemeContext);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    inputFocused = _useState2[0],
    setInputFocused = _useState2[1];
  var addVariant = variant !== 'default';
  var variantClass = variant && variant.charAt(0).toUpperCase() + variant.slice(1);
  var inputGroupInputClasses = cx({
    inputGroupInput: true,
    [styles["inputGroupInputVariant".concat(variantClass)]]: addVariant
  });
  var buttonClasses = cx({
    inputGroupButton: true,
    inputGroupButtonDisable: loading
  });
  var id = useRef(initId || Utility.generateUID('input-group')).current;
  var _useState3 = useState(initText),
    _useState4 = _slicedToArray(_useState3, 2),
    text = _useState4[0],
    setText = _useState4[1];
  var onClick = function onClick() {
    if (!hasError) {
      onSubmit(text);
    }
  };
  var handleChangeText = function handleChangeText(text) {
    setText(text);
    onChangeText(text);
  };
  useEffect(function () {
    setText(initText);
  }, [initText]);
  var renderLoader = function renderLoader() {
    return /*#__PURE__*/_jsx("div", {
      className: styles.inputGroupLoader,
      children: /*#__PURE__*/_jsx(SpinnerIndicator, {
        size: "20px"
      })
    });
  };
  var renderArrowIcon = function renderArrowIcon(addVariant) {
    return /*#__PURE__*/_jsx(Icon, {
      className: cx({
        inputGroupArrow: true,
        ["inputGroupArrowVariant".concat(variantClass)]: addVariant
      }),
      type: "primary-link",
      fill: "",
      height: "20px",
      width: "20px"
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: cx({
      inputGroup: true,
      inputGroupDarkBackground: theme === 'darkBackground',
      ["inputGroupVariant".concat(variantClass)]: addVariant,
      inputGroupError: hasError,
      inputGroupLoading: loading,
      inputGroupSmall: small,
      inputGroupLarge: !small,
      inputGroupArrowButton: arrowButton
    }),
    "data-e2e-name": "input_group",
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.inputGroupTextInputWrapper,
      children: /*#__PURE__*/_jsx(TextInput, {
        autoFocus: autoFocus,
        hasError: hasError,
        id: id,
        inputAttributes: inputAttributes,
        inputClassName: classnames(inputClassName, inputGroupInputClasses),
        onChangeText: handleChangeText,
        onFocus: function onFocus() {
          return setInputFocused(true);
        },
        onBlur: function onBlur() {
          return setInputFocused(false);
        },
        onKeyDown: onKeyDown,
        onSubmit: onSubmit,
        placeholder: placeholder,
        small: small,
        text: text,
        variant: variant
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.inputGroupButtonWrapper,
      "data-e2e-name": "input_group_button_wrapper",
      children: [/*#__PURE__*/_jsx(Theme, {
        theme: variant === 'wwBlue' ? 'darkBackground' : 'lightBackground',
        children: /*#__PURE__*/_jsx(Button, {
          className: classnames(buttonClasses, buttonClassName, {
            [styles["inputGroupButtonVariant".concat(variantClass)]]: addVariant,
            [styles.inputGroupButtonFocused]: inputFocused,
            [styles.inputGroupButtonUnfocused]: !inputFocused,
            [styles.inputGroupButtonError]: hasError
          }),
          onClick: onClick,
          disabled: hasError || loading,
          attributes: buttonAttributes,
          children: buttonText
        })
      }), loading && renderLoader(), arrowButton && !loading && renderArrowIcon(addVariant)]
    })]
  });
};